import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Svg } from "../svg/Svg";
export const UndoIcon = React.forwardRef((props, ref) => (_jsx(Svg, { "data-testid": "UndoIcon", ...props, ref: ref, children: _jsx("path", { fill: "currentColor", d: "M.5,6a.5.5,0,0,1-.492-.41L0,5.5V.5A.5.5,0,0,1,.992.409L1,.5V4.13A8,8,0,1,1,8,16a.5.5,0,1,1,0-1A7,7,0,1,0,1.68,5H5.5a.5.5,0,0,1,.492.41L6,5.5a.5.5,0,0,1-.41.492L5.5,6Z" }) })));
UndoIcon.displayName = "UndoIcon";
